var HttpUtils = require('../../util/http_utils');
var ObjectUtils = require('../../util/object_utils');
var DomUtils = require('../../util/dom_utils');
var Logger = require('../../util/logger_utils');

var seekBarElem,
    imgElem,
    filmstripFeedData,
    imageArrayPositions;

function Filmstrip(feedUri) {
    if (!feedUri) return console.debug('Filmstrip functionality not working because no filmstrip uri was provided.');
    getEsbFeed(feedUri, function(filmstrip) {
        filmstripFeedData = filmstrip;
        // console.log(filmstripFeedData)
        imgElem = createImageElement();
        imageArrayPositions = filmstripFeedData['imageCount'] - 1;
        DomUtils.waitForElement('class', 'bitdash-prog', function(success, element) {
            if (success) {
                element.appendChild(imgElem);
                element.addEventListener('mousemove', showFilmStripImage, false);
                element.addEventListener('mouseout', hideFilmstripImage, false);
                seekBarElem = document.getElementsByClassName('bitdash-prog-bar')[0];
            }
        });
    });
}

function showFilmStripImage(event) {
    var noOfScreensOpened = document.querySelectorAll(
        '.bitdash-settings--seasons.is-shown,' +
        '.bitdash-settings--custom.is-shown,' +
        '.bitdash-settings--videoquality.is-shown,' +
        '.bitdash-settings--next.is-shown'
    ).length;
    if (noOfScreensOpened <= 0) {
        var computedStyle = getComputedStyle(seekBarElem);
        var elementWidth = seekBarElem.clientWidth;   // width with padding
        elementWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
        var mousePosX = event.clientX - seekBarElem.getBoundingClientRect().left;
        if (mousePosX > elementWidth || mousePosX < 0) return;
        // console.log(elementWidth, mousePosX, (mousePosX * 100 / elementWidth) / 100 * filmstripFeedData['imageCount']);
        var correction = 2;
        var imagePos = parseInt((mousePosX * 100 / elementWidth) / 100 * filmstripFeedData['imageCount']) + correction;
        imagePos = imagePos > imageArrayPositions ? imageArrayPositions : imagePos;
        imgElem.src = filmstripFeedData['thumbnails'][imagePos];
        imgElem.style.left = mousePosX - (imgElem.clientWidth / 2) + 'px';
    }
}

function hideFilmstripImage() {
    imgElem.src = '';
}

function createImageElement() {
    var elem = document.createElement('img');
    elem.setAttribute('class', 'player-filmstrip');
    return elem;
}

/**
 * Fetch the feed from the ESB by URI
 * @param {String} feedUri
 * @param {Function} callback
 * @param {Object} callback.content
 */
function getEsbFeed(feedUri, callback) {
    HttpUtils.get(feedUri, function(success, content) {
        if (success && ObjectUtils.isJsonString(content)) {
            callback(JSON.parse(content));
        } else {
            Logger.warn('Could not load filmstrip feed. Error getting url \'' + feedUri + '\'. Invalid URI or Body');
        }
    });
}

module.exports = Filmstrip;



// WEBPACK FOOTER //
// ./src/modules/filmstrip/filmstrip.js